exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".code-view-wrapper{padding:0}.code-view-wrapper .code-view-error{max-height:200px;padding:18px;color:red}\n", ""]);

